import { render } from "./IconFaqBalloon.vue?vue&type=template&id=99cb398e"
import script from "./IconFaqBalloon.vue?vue&type=script&lang=js"
export * from "./IconFaqBalloon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__